import Accordion from 'accordion-js';

export default function initAccordion() {
  if (document.querySelector('.accordion-container') === null) return;
  new Accordion('.accordion-container', {
    openOnInit: [0],
  });
}